import { createFileRoute } from '@tanstack/react-router'

import { VendorPage } from '@/vendors/VendorPage'

export const Route = createFileRoute('/admin/vendors/$vendorId')({ component: VendorRoute })

function VendorRoute() {
  const { vendorId } = Route.useParams()
  return <VendorPage vendorID={vendorId} />
}
